import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-skip-confirmation-dialog',
  imports: [CommonModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './skip-confirmation-dialog.component.html',
  styleUrl: './skip-confirmation-dialog.component.scss',
})
export class SkipConfirmationDialogComponent {
  @Input() partnerName = '';
  @Input() integrationEnabled = false;
  @Input() integrationEntityName = '';
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  get skipConfirmMessageKey(): string {
    return this.integrationEnabled
      ? 'lang.skip_confirm_message_integration'
      : 'lang.skip_confirm_message';
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}

